
// src/config/axiosConfig.js

import axios from 'axios';

// Cria uma instância do Axios com a URL base configurada pela variável de ambiente
const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  timeout: 180000, // Timeout de 180 segundos (180000 milissegundos)
});

// Interceptador para incluir o token em todas as requisições
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token'); // Obtém o token armazenado no localStorage
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`; // Adiciona o token ao cabeçalho de todas as requisições
    }
    return config;
  },
  (error) => {
    return Promise.reject(error); // Em caso de erro, rejeita a promessa
  }
);

// Interceptador para lidar com as respostas, caso necessário
api.interceptors.response.use(
  (response) => response, // Retorna a resposta normalmente
  (error) => {
    // Lidar com erros (ex.: expiração do token ou outros erros)
    return Promise.reject(error);
  }
);

export default api;